"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _links = require("self-service-api/core/utilities/links");

var _UIAdminOnlyWrapper = _interopRequireDefault(require("ui-addon-upgrades/decorators/UIAdminOnlyWrapper"));

var _AdminModalTypes = require("ui-addon-upgrades/_core/common/constants/AdminModalTypes");

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var AddAdditionalSeatsButton = function AddAdditionalSeatsButton(_ref) {
  var className = _ref.className,
      use = _ref.use,
      merchandiseId = _ref.merchandiseId,
      trackingSource = _ref.trackingSource;

  var handleClick = function handleClick() {
    tracker.track('addAdditionalSeatsClick', {
      merchandiseName: _ImmutableMerchandiseIdMap.default[merchandiseId].trackingName,
      merchandiseId: merchandiseId,
      trackingSource: trackingSource
    });
  };

  return _react.default.createElement(_UIAdminOnlyWrapper.default, {
    adminType: "team",
    modalType: _AdminModalTypes.REQUEST_ADDITIONAL_SEATS,
    merchandiseId: merchandiseId
  }, _react.default.createElement(_UIButton.default, {
    "data-selenium-id": trackingSource + "-" + merchandiseId + "-additional-seats-button",
    className: className,
    use: use,
    href: (0, _links.getPaidUserManagementUrl)(),
    "data-reagan-primary-cta": true,
    onClick: handleClick,
    target: '_blank',
    truncate: true
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pricingCtas.buyAdditionalUsers"
  })));
};

AddAdditionalSeatsButton.propTypes = {
  className: _propTypes.default.string,
  use: _propTypes.default.string,
  merchandiseId: _propTypes.default.number.isRequired,
  trackingSource: _propTypes.default.string.isRequired
};
var _default = AddAdditionalSeatsButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/additionalSeats/AddAdditionalSeatsButton.js
// module id = 773
// module chunks = 5 6